import React__default from 'react';

var TransitionGroupContext = React__default.createContext(null);

export { TransitionGroupContext as default };
